
import { useParams } from 'react-router-dom';
import { PedidosFormState } from '../../../context/pedidos/PedidosFormState';
import { Form } from './form';

export const PedidosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Ver Pedido":"Crear Pedidos";

  return (
    <PedidosFormState>
         <br />
        <Form title={title} />
    </PedidosFormState>
  );
};
